import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { LAYOUT_CONFIG } from '@/lib/config/layout'
import { stringToSlug } from '@/lib/utils'
import { ConsentDialogLink } from '@c15t/nextjs'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { FooterMenuMobileCopyItem } from './footer-menu-mobile-copy-item'

export const FooterMenuMobile = () => {
  const t = useTranslations('footer')
  return (
    <Accordion type='single' collapsible className='w-full space-y-2'>
      {LAYOUT_CONFIG.FOOTER.menuMobile.map((menu) => (
        <AccordionItem
          value={menu.title}
          className='space-y-1 border-0'
          key={menu.title}
        >
          <AccordionTrigger
            className='py-0 font-sans text-sm font-semibold leading-7 tracking-[3%] text-light'
            hasPlusIcon
            aria-label={`Mở menu ${menu.title}`}
          >
            {t(menu.title)}
          </AccordionTrigger>
          <AccordionContent className='space-y-1.5'>
            {menu.items.map((item) => {
              if ('copy' in item && item.copy) {
                return (
                  <FooterMenuMobileCopyItem
                    key={item.label}
                    label={t(item.label)}
                    gaTrackingValue={`footer__menu-mobile__${stringToSlug(menu.title)}__${stringToSlug(item.label)}`}
                  />
                )
              }
              if ('action' in item && item.action === 'consent-dialog') {
                return (
                  <ConsentDialogLink
                    key={item.label}
                    noStyle
                    className='inline-block text-xs leading-5 text-neutral-300'
                  >
                    {t(item.label)}
                  </ConsentDialogLink>
                )
              }
              const isExternal = item.url.startsWith('http')
              return (
                <Link
                  key={item.url}
                  href={item.url}
                  className='inline-block w-full text-xs leading-5 text-neutral-300'
                  target={isExternal ? '_blank' : undefined}
                  rel={isExternal ? 'noopener noreferrer' : undefined}
                  ga-tracking-value={`footer__menu-mobile__${stringToSlug(menu.title)}__${stringToSlug(item.label)}`}
                  ga-tracking-label={t(item.label)}
                  prefetch={false}
                >
                  {t(item.label)}
                </Link>
              )
            })}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
